module.exports = __webpack_public_path__ + "static/img/strona_007.306419f4.jpg";